<div class="project-edit-page page">
    <main class="project-edit-page__content content">

        <header>
            <div class="page-title">Edit Project</div>
            <div class="page-subtitle">Adjust your ECHO project</div>
        </header>

        <section class="project-edit-page__section-content">
            <div class="project-edit-page__section-title">Project details</div>

            <div>Enter some details about your project</div>

            <dds-input [formControl]="inputFormCtrl" [label]="inputOptions.label"
                [labelPosition]="inputOptions.labelPosition" [placeholder]="inputOptions.placeholder"
                [isRequired]="inputOptions.isRequired" [isInverse]="inputOptions.isInverse"
                [isError]="inputOptions.isError" [readonly]="inputOptions.readonly" [size]="inputOptions.size"
                [description]="inputOptions.description" [errorMessage]="inputOptions.errorMessage"
                [errorState]="inputOptions.errorState" [descriptionType]="inputOptions.descriptionType"
                [maxLength]="inputOptions.maxLength" [maxLengthPosition]="inputOptions.maxLengthPosition"
                [textAlign]="inputOptions.textAlign" [type]="inputOptions.type" (valueChanged)="changeValue()"
                (onBlur)="onBlur()"></dds-input>

            <dds-textarea [formControl]="textareaFormCtrl" [label]="textareaOptions.label"
                [labelPosition]="textareaOptions.labelPosition" [placeholder]="textareaOptions.placeholder"
                [description]="textareaOptions.description" [minHeight]="textareaOptions.minHeight"
                [isRequired]="textareaOptions.isRequired" [isInverse]="textareaOptions.isInverse"
                [isError]="textareaOptions.isError" [errorMessage]="textareaOptions.errorMessage"
                [errorState]="textareaOptions.errorState" [maxLength]="textareaOptions.maxLength"
                [maxLengthPosition]="textareaOptions.maxLengthPosition" [size]="textareaOptions.size"
                [readonly]="textareaOptions.readonly" (valueChanged)="descriptionValueChanged()"></dds-textarea>
        </section>

        <section class="buttons-wrapper">
            <dds-button [theme]="cancelButtonOptions.theme" [kind]="cancelButtonOptions.kind"
                [size]="cancelButtonOptions.size" [width]="cancelButtonOptions.width" [icon]="cancelButtonOptions.icon"
                [isIconLeft]="cancelButtonOptions.isIconLeft" [role]="cancelButtonOptions.role"
                [isInverse]="cancelButtonOptions.isInverse" [isColorBg]="cancelButtonOptions.isColorBg"
                [isLoading]="cancelButtonOptions.isLoading" [ariaLabel]="cancelButtonOptions.ariaLabel"
                [customClass]="cancelButtonOptions.customClass" (clicked)="cancelClick($event)">Cancel</dds-button>

            <dds-button [theme]="saveButtonOptions.theme" [kind]="saveButtonOptions.kind"
                [size]="saveButtonOptions.size" [width]="saveButtonOptions.width" [icon]="saveButtonOptions.icon"
                [isIconLeft]="saveButtonOptions.isIconLeft" [role]="saveButtonOptions.role"
                [isInverse]="saveButtonOptions.isInverse" [isColorBg]="saveButtonOptions.isColorBg"
                [isLoading]="saveButtonOptions.isLoading" [ariaLabel]="saveButtonOptions.ariaLabel"
                [customClass]="saveButtonOptions.customClass" (clicked)="saveButtonClick($event)">Save</dds-button>
        </section>

    </main>
</div>